// extracted by mini-css-extract-plugin
module.exports = {"collectionTitle":"SMmjd","collectionName":"_3yBzR","collectionTeaser":"ZtauQ"};